export const featureFlags = {
  // Career app feature flags
  search: 'search_version',
  public_profile: 'public_profile',
  new_profile_completeness_score: 'new_profile_completeness_score',
  publicProfile: 'public_profile',
  enable_custom_field_links: 'enable_custom_field_links',
  isProfileTooltipsEnabled: 'is_profile_tooltips_enabled',
  isSkillsRatingLevelsDescriptionEnabled: 'TMP_proficiency_level_descriptions_timestamp',
  isOppGainedSkillsEnabled: 'gained_skills_mentorship_learning',
  isCareerPathNewExplainabilityFlag: 'career_path_new_matching',
  // work
  mosaic: 'mosaic',
  mosaicV2: 'mosaic_v2',
  mosaicUploadFiles: 'mosaic_upload_files',
  mosaicUploadImage: 'mosaic_upload_image',
  mosaicNewUi: 'mosaic_new_ui',
  userTasks: 'user_tasks',
  use_harmonized_skills_autocomplete: 'use_harmonized_skills_autocomplete',
  is_new_matching_explainability: 'is_new_matching_explainability',
  mosaicMatchSorting: 'mosaic_match_sorting',
  career_path_saved_desired_paths: 'CP_Desired_role_and_saved_path',
  mosaicLastSlotWarning: 'mosaic_last_slot_visual',
  mosaicTalentPools: 'mosaic_talent_pools',

  // Hire feature flags
  jobBuilder: 'job_bulder_r1',
  enable_project_bulk_actions: 'enable_project_bulk_actions',
  studioShowTableOfContent: 'studio_show_table_of_content',
  studioCoOwner: 'studio_co_owners',
  studioNewProgramTypes: 'studio_new_program_types',

  // Skills-foundation feature flags
  skillsInventoryDownloadProfile: 'skillsInventoryDownloadProfile',
  skillsManagementV2: 'skills_management_v2_q1_2025',
  cascading: 'sf_cascading',
  bulkEdit: 'Bulk_Edit_R1',
  tasks: 'tasks_ontology_r2',
  talentPools: 'talent_pools',
  skillsInventory: 'keep_skills_inventory',
  taskAutomationAssistant: 'task_automation_assistant',
  taskAssistantRequestAgent: 'task_assistant_request_agent',
  taskAssistantContextualized: 'task_assistant_contextualized',
  slAddSkillToProfile: 'SL_Add_skill_to_profile',
  oppsAddSkillToProfile: 'Opps_add_skill_to_profile',
  aiIndexCostSaving: 'ai_index_cost_saving',
  aiIndexAutomationStatus: 'ai_index_automation_status',
  newFteCalculation: 'new_fte_calculation',
  proficiencyDescriptionCharacterLimit: 'Proficiency_description_character_limit',
  aiIndexJobFunctionToggleFilter: 'ai_index_job_function_toggle_filter',

  // general feature flags
  newNavigation: 'newNavigation',
  skillComponent: 'Skill_component_R1',
  SL_Find_opportunities: 'SL_Find_opportunities',
  agentTmp: 'agent_tmp',
} as const;
